import { AxiosError, AxiosResponse } from "axios";
import { gateway } from "../../../../../../gateway";
import type { IInvoice } from "../../../../create/interfaces/invoice.interfaces";

export interface GetInvoiceParams {
  invoiceUid?: string;
  /** Any billed event UID works with GET /invoices?jobEventUid=… (first entry is used). */
  jobEventsUids?: string[];
}

type Token = string | null | undefined;

export const getInvoice = async (params: GetInvoiceParams | string, tokenFromQuery?: Token): Promise<IInvoice | null> => {
  let url: string;
  const token = sessionStorage.getItem("token");

  if (typeof params === "string") {
    url = `/invoices/${params}`;
  } else {
    const jobEventUid = params.jobEventsUids?.find(Boolean);

    if (params.invoiceUid) {
      url = `/invoices/${params.invoiceUid}`;
    } else if (jobEventUid) {
      url = `/invoices?jobEventUid=${encodeURIComponent(jobEventUid)}`;
    } else {
      throw new Error("Either invoiceUid or jobEventsUids must be provided");
    }
  }

  try {
    const response = await gateway.get<AxiosResponse<IInvoice>>(url, {
      headers: tokenFromQuery ? { Authorization: `Bearer ${tokenFromQuery}` } : { Authorization: `Bearer ${token}` },
    });

    return response.data.data;
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 404) return null;
    throw error;
  }
};
